import _ from 'lodash';

export function latestStatus(statusObjects) {
    // sort date
    const sorted = _.sortBy(_.toPairs(statusObjects), 1);
    // console.log(statusObjects);

    if (sorted.length === 0) {
        return 'Unknown';
    }

    const latest = sorted[sorted.length - 1];
    return latest[0];
    // // TODO: localization
    // switch (latest[0]) {
    //     case 'payment':
    //         return 'Awaiting Payment';
    //     case 'shipment':
    //         return 'Awaiting Shipment';
    //     case 'shipped':
    //         return 'Shipped';
    //     case 'canceled':
    //         return 'Canceled'
    // }
    // return 'Unknown';
}

export function findCategory(categories, id) {
    const cat = _.find(categories, { id: id });
    return cat;
}


// WEBPACK FOOTER //
// ./src/utils/Utils.js